import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { AvatarInterface, setEditId, setEditError, selectAvatarById } from "../../../store/mine_craft/avatarsSlice";
import { updateAvatar, fetchAvatar } from "../../../actions/mine_craft/avatarsActions";
import { objToFormData } from "../../../helpers/FormHelper";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";

const Edit = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const id: any = useAppSelector(state => state.mineCraft.avatars.editId);
  const error = useAppSelector(state => state.mineCraft.avatars.editError);
  const avatar = useAppSelector(state => id ? selectAvatarById(state, id) : undefined);
  const params: any = { ...avatar };

  useEffect(() => {
    if (id) {
      dispatch(fetchAvatar(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    dispatch(setEditId(null));
  }, [location, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(rawData: any) {
    const data = { ...rawData };

    handleSave(data).catch(console.error);
  }

  async function handleSave(data: AvatarInterface) {
    const formData: any = objToFormData(data);
    const resultAction = await dispatch(updateAvatar({ id, data: formData }));

    if (updateAvatar.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-avatar'>
        <h6 className="v-content-label">Edit Avatar</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form params={params} onFinish={onFinish} />
      </div>
    </DrawerRight>
  )
}

export default Edit;
